module.exports = __webpack_public_path__ + "img/redbook-qr.1ecd5023.png";